import { jsx as _jsx } from "react/jsx-runtime";
import { ClipStatus } from "@air/api/types";
import { memo } from "react";
import { AssetGalleryCardFailedTranscode } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardFailedTranscode";
import { AssetGalleryCardProcessing } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardProcessing";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
export const ContentCollectionGalleryAssetThumbnail = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    if ([
        ClipStatus.failed,
        ClipStatus.nonTranscodable
    ].includes(clip.status)) {
        return /*#__PURE__*/ _jsx(AssetGalleryCardFailedTranscode, {
            className: "size-full",
            ext: clip.ext
        });
    }
    if (!clip.assets.image) {
        return /*#__PURE__*/ _jsx(AssetGalleryCardProcessing, {
            className: "size-full",
            ext: clip.ext
        });
    }
    return /*#__PURE__*/ _jsx(ImgixImage, {
        alt: clip.description || "",
        fallbackUrl: getCloudFrontUrlFromImgixUrl(clip.assets.image),
        height: 240,
        imgixParams: {
            auto: "compress",
            fit: "clip",
            cs: "origin"
        },
        src: clip.assets.image
    });
});
ContentCollectionGalleryAssetThumbnail.displayName = "ContentCollectionGalleryAssetThumbnail";
